import { BaseController } from "./baseController";

export const BaseGridApi = {
	/** Loads saved grid settings for a specific grid */
	loadGridSettings: (controller: string, gridName: string) => {
		const Get = BaseController.GetFn(controller);
		return Get<string | null>("LoadSettingsDyn", { gridName });
	},

	/** Saves grid settings for a specific grid. Pass empty string to clear. */
	saveGridSettings: (controller: string, gridName: string, settingsJson: string) => {
		const Post = BaseController.PostFn(controller);
		return Post<void>("SaveSettings", null, {
			settings: settingsJson,
			gridName,
		});
	},

	/** Gets grid column definitions from the backend */
	getGridColumns: <T>(controller: string, gridName: string) => {
		const Get = BaseController.GetFn(controller);
		return Get<T>("GetGridColumns", { gridName });
	},
};
